import './style.scss';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger)
export function our_story_block() {
  const block = document.querySelector('.our_story_block');
  if (!block) return;
  const title = block.querySelector('.title');
  const description = block.querySelector('.description');
  const whiteCastleLeft = block.querySelector('.left-image');
  const centerCastle = block.querySelector('.center-image');
  const whiteCastleRight = block.querySelector('.right-image');
  
  if (!(centerCastle && whiteCastleLeft && whiteCastleRight)) return;
  // Main timeline for castle animations
  gsap.timeline({
    defaults: { duration: 1.5, ease: 'power4.in' },
    scrollTrigger: {
      trigger: block,
      toggleActions: 'play none none none',
      start: 'top center',
      end: 'bottom 20%',
    },
  })
      .set(centerCastle, { scale: 1.5 })
      .from(centerCastle, { opacity: 0 })
      .addLabel('show-all')
      .to(centerCastle, { scale: 1 }, 'show-all')
      .from(whiteCastleLeft, { yPercent: 100, x: '-10vw' }, 'show-all')
      .from(whiteCastleRight, { yPercent: 100, x: '10vw' }, 'show-all');

// Independent ScrollTrigger for title
  gsap.from(title, {
    yPercent: -100,
    opacity: 0,
    duration: 1.2,
    ease: 'power4.out',
    scrollTrigger: {
      trigger: title,
      start: 'top 60%',
      toggleActions: 'play none none none',
    },
  });

// Independent ScrollTrigger for description
  gsap.from(description, {
    yPercent: -100,
    opacity: 0,
    duration: 1.2,
    ease: 'power4.out',
    scrollTrigger: {
      trigger: description,
      start: 'top 60%',
      toggleActions: 'play none none none',
    },
  });
  
}
